import TestimonialsContent from "$lib/data/generated/content/testimonials/data.json";

import { uploads as TestimonialsUploads } from "$lib/data/generated/uploads/testimonials/uploads";

const content = {
	["testimonials"]: TestimonialsContent
};
const uploads = {
	...TestimonialsUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
